var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner_text",class:_vm.titleCn == '新闻资讯'?'black':''},[_c('p',[_vm._v(_vm._s(_vm.titleEn))]),_c('h3',[_vm._v(_vm._s(_vm.titleCn))])]),_c('img',{attrs:{"src":_vm.img}})])
}
var staticRenderFns = []

export { render, staticRenderFns }